var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#000",
    strokeDasharray: "8 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10h-.5V9a2.5 2.5 0 00-5 0v1H9c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-3 4.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1.55-4.5h-3.1V9c0-.855.695-1.55 1.55-1.55.855 0 1.55.695 1.55 1.55v1z",
    fill: "#000"
  })));
}
export default SvgLocked;